import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FiClipboard, FiChevronLeft, FiChevronRight, FiSettings } from "react-icons/fi";
import { FaHandshake } from "react-icons/fa";
import { TbFileSettings } from "react-icons/tb";
import { MdBusinessCenter, MdSpaceDashboard, MdAttachMoney, MdTimeline, MdGroups, MdEventAvailable } from "react-icons/md";
import { useAuth } from "@/auth/useAuth";
const Sidebar = ({ isMobileOpen, toggleMobileSidebar }) => {
    const [isCollapsed, setIsCollapsed] = React.useState(false);
    const location = useLocation();
    const { user, loading } = useAuth();
    React.useEffect(() => {
        if (location.pathname === "/board") {
            setIsCollapsed(true);
        }
    }, [location.pathname]);
    const menuItems = [
        { path: "/board", label: "Dashboard", icon: _jsx(MdSpaceDashboard, {}), roles: [1, 2, 3, 99] },
        { path: "/tasks", label: "Tâches", icon: _jsx(FiClipboard, {}), roles: [1, 2, 3, 99] },
        { path: "/timeline", label: "Diagramme de Gantt", icon: _jsx(MdTimeline, {}), roles: [99] },
        { path: "/reports/charges", label: "Charges", icon: _jsx(MdAttachMoney, {}), roles: [3, 99] },
        { path: "/time-off", label: "Absences", icon: _jsx(MdEventAvailable, {}), roles: [1, 2, 3, 4, 99] },
        { path: "/clients", label: "Clients", icon: _jsx(FaHandshake, {}), roles: [3, 99] },
        { path: "/directory", label: "Personnel", icon: _jsx(MdGroups, {}), roles: [3, 4, 99] },
        { path: "/projects", label: "Projets", icon: _jsx(MdBusinessCenter, {}), roles: [2, 3, 99] },
        { path: "/settings", label: "Paramétrage", icon: _jsx(TbFileSettings, {}), roles: [2, 3, 99] },
        { path: "/configuration", label: "Application", icon: _jsx(FiSettings, {}), roles: [99] },
    ];
    const toggleCollapse = () => setIsCollapsed(collapsed => !collapsed);
    // on ne rend rien tant que l'info utilisateur n'est pas chargée
    if (loading) {
        return null;
    }
    // Filtrer selon le rôle de l'utilisateur
    const filteredMenu = menuItems.filter(item => user && user.role_hierarchy ? item.roles.includes(user.role_hierarchy) : false);
    return (_jsxs(_Fragment, { children: [isMobileOpen && (_jsx("div", { className: "fixed inset-0 z-40 bg-black opacity-50 md:hidden", onClick: toggleMobileSidebar })), _jsx("div", { className: `
          fixed inset-y-0 left-0 z-50 bg-gray-800 text-white transform transition-all duration-300
          ${isMobileOpen ? "translate-x-0" : "-translate-x-full"}
          md:relative md:translate-x-0 ${isCollapsed ? "md:w-16" : "md:w-64"}
        `, children: _jsxs("div", { className: "flex flex-col h-full", children: [_jsx("div", { className: "hidden md:flex justify-end p-2", children: _jsx("button", { onClick: toggleCollapse, className: "p-2 text-white hover:bg-gray-700 transition", children: isCollapsed ? _jsx(FiChevronRight, { size: 20 }) : _jsx(FiChevronLeft, { size: 20 }) }) }), _jsx("nav", { className: "flex-1 p-4 space-y-2", children: filteredMenu.map(item => (_jsxs(NavLink, { to: item.path, title: item.label, className: ({ isActive }) => `flex items-center gap-3 p-2 rounded hover:bg-gray-700 ${isActive ? "bg-gray-700" : ""}`, onClick: () => {
                                    if (window.innerWidth < 768 && isMobileOpen)
                                        toggleMobileSidebar();
                                }, children: [_jsx("span", { className: "text-xl", children: item.icon }), !isCollapsed && _jsx("span", { children: item.label })] }, item.path))) })] }) })] }));
};
export default Sidebar;
